// Language configuration - Single Source of Truth
export const LANGUAGE_INFO = [
  {
    code: 'es',
    name: 'Español',
    image: '/assets/flags/spain.webp',
    locale: 'es_ES'
  },
  {
    code: 'it',
    name: 'Italiano',
    image: '/assets/flags/italy.webp',
    locale: 'it_IT'
  },
  {
    code: 'nap',
    name: 'Napulitano',
    image: '/assets/flags/napoli.webp',
    locale: 'nap_IT'
  },
  {
    code: 'gl',
    name: 'Galego',
    image: '/assets/flags/galicia.webp',
    locale: 'gl_ES'
  },
  {
    code: 'ca',
    name: 'Català',
    image: '/assets/flags/catalonia.webp',
    locale: 'ca_ES'
  },
  {
    code: 'eu',
    name: 'Euskara',
    image: '/assets/flags/basque-country.webp',
    locale: 'eu_ES'
  },
  {
    code: 'pt',
    name: 'Português',
    image: '/assets/flags/portugal.webp',
    locale: 'pt_PT'
  },
  {
    code: 'en',
    name: 'English',
    image: '/assets/flags/united-kingdom.webp',
    locale: 'en_US'
  },
  {
    code: 'fr',
    name: 'Français',
    image: '/assets/flags/france.webp',
    locale: 'fr_FR'
  },
  {
    code: 'de',
    name: 'Deutsch',
    image: '/assets/flags/germany.webp',
    locale: 'de_DE'
  }
]

// Fallback mapping - Strategic language relationships for future two-level content fallback
// currently everything falls back to 'es'
export const LANGUAGE_FALLBACKS = {
  nap: 'it', // Napolitano → Italiano (dialectal relationship)
  eu: 'es', // Euskara → Español (co-official in Spain)
  ca: 'es', // Català → Español (co-official in Spain)
  it: 'es', // Italiano → Español (Fallback to default)
  fr: 'en', // Francés → English (UE language)
  de: 'en', // Alemán → Inglés (Germanic languages)
  pt: 'es', // Portugués → Español (Fallback to default)
  en: 'es', // Inglés → Español (base language)
  gl: 'es', // Galego → Español (co-official in Spain)
  es: null // Español - No fallback (base language)
}

// Derived constants (automatically generated from LANGUAGE_INFO)
export const SUPPORTED_LANGUAGES = LANGUAGE_INFO.map(lang => lang.code)
export const DEFAULT_LANGUAGE = LANGUAGE_INFO[0].code

// Helper functions to access language data
export const getLanguageInfo = (code) => {
  return LANGUAGE_INFO.find(lang => lang.code === code)
}

export const getLocaleCode = (langCode) => {
  const langInfo = getLanguageInfo(langCode)
  return langInfo?.locale || LANGUAGE_INFO[0].locale // fallback to first language
}

export const getLanguageName = (code) => {
  const langInfo = getLanguageInfo(code)
  return langInfo?.name || 'Unknown'
}

export function getLanguageFromPathname (pathname, fallback = DEFAULT_LANGUAGE) {
  const pathLang = pathname.split('/')[1]
  return SUPPORTED_LANGUAGES.includes(pathLang) ? pathLang : fallback
}

export function getLanguageFromPath (fallback = DEFAULT_LANGUAGE) {
  return getLanguageFromPathname(window.location.pathname, fallback)
}

export const getHreflangLinks = () => {
  const baseUrl = 'https://memodiez.com'

  // Generate hreflang for each supported language
  const languageLinks = LANGUAGE_INFO.map(lang => ({
    href: `${baseUrl}/${lang.code}`,
    hreflang: lang.code
  }))

  // Add x-default pointing to default language
  const defaultLink = {
    href: `${baseUrl}/${DEFAULT_LANGUAGE}`,
    hreflang: 'x-default'
  }

  return [...languageLinks, defaultLink]
}
